import { Empty, Spin } from 'antd';
import { StyledAvaialbleLiveTasks } from './AvaialbleLiveTasks.styled';
import useAvaialbleLiveTasks from './useAvaialbleLiveTasks.hook';
import LiveTaskCard from './LiveTaskCard/LiveTaskCard';

export default function AvaialbleLiveTasks({
  selectedActivity,
  setSelectedActivity,
}) {
  const { state } = useAvaialbleLiveTasks();
  return (
    <StyledAvaialbleLiveTasks>
      <Spin spinning={state.loading}>
        <div className="title">Choose a LIVE task</div>
        <div className="list-container">
          {state.activities
            .filter(
              (activity) =>
                activity.type == state.selectedType || !state.selectedType
            )
            .map((activity, index) => {
              const { theme } = activity;
              return (
                <LiveTaskCard
                  key={index}
                  name={activity.name}
                  englishName={activity.englishName}
                  thumb={theme.thumb}
                  onClick={() => setSelectedActivity(activity)}
                  selected={selectedActivity?.id === activity.id}
                />
              );
            })}

          {state.activities.length === 0 && !state.loading && (
            <Empty
              description="No live tasks available"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          )}
        </div>
      </Spin>
    </StyledAvaialbleLiveTasks>
  );
}
